/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferralRewardPercentageRequest
 */
export interface UpdateReferralRewardPercentageRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateReferralRewardPercentageRequest
     */
    rewardInPercent: number;
    /**
     * Admin comment
     * @type {string}
     * @memberof UpdateReferralRewardPercentageRequest
     */
    comment: string;
}

/**
 * Check if a given object implements the UpdateReferralRewardPercentageRequest interface.
 */
export function instanceOfUpdateReferralRewardPercentageRequest(value: object): value is UpdateReferralRewardPercentageRequest {
    if (!('rewardInPercent' in value) || value['rewardInPercent'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function UpdateReferralRewardPercentageRequestFromJSON(json: any): UpdateReferralRewardPercentageRequest {
    return UpdateReferralRewardPercentageRequestFromJSONTyped(json, false);
}

export function UpdateReferralRewardPercentageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralRewardPercentageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rewardInPercent': json['rewardInPercent'],
        'comment': json['comment'],
    };
}

export function UpdateReferralRewardPercentageRequestToJSON(value?: UpdateReferralRewardPercentageRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rewardInPercent': value['rewardInPercent'],
        'comment': value['comment'],
    };
}

